module.exports = "/_next/static/images/img_close_pc-60276e399422a27c16c471f7d7dcbd7c.png";